import React from "react";
import { Card, CardContent } from "../../components/ui/card";

export default function AdminResumoCards({ dados }) {
  const total     = dados.length;
  const hoje      = dados.filter((a) => new Date(a.inicio).toDateString() === new Date().toDateString()).length;
  const pendentes = dados.filter((a) => a.status === "pendente").length;

  const stats = [
    { id: "total",    emoji: "📅", label: "Total",     value: total,     className: "bg-muted" },
    { id: "today",    emoji: "🔥", label: "Hoje",      value: hoje,      className: "bg-amber-50 border-amber-100" },
    { id: "pending",  emoji: "⏳", label: "Pendentes", value: pendentes, className: "bg-blue-50 border-blue-100" },
  ];

  return (
    <div id="admin-summary-cards-container" className="grid grid-cols-3 gap-3">
      {stats.map(({ id, emoji, label, value, className }) => (
        <Card key={id} id={`admin-summary-stat-${id}`} className={className}>
          <CardContent className="flex flex-col items-center justify-center p-3 text-center">
            <span className="text-xl">{emoji}</span>
            <span className="text-lg font-bold text-foreground">{value}</span>
            <span className="text-xs text-muted-foreground">{label}</span>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
